import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { fadeInOut } from 'assets/TS/SharedAnimations';
import { Subscription } from 'rxjs';

export interface StackedAddressItem {
	label: string;
	id;
	isChecked?: boolean;
}
@Component({
	selector: 'app-stacked-addresses-pick',
	templateUrl: './stacked-addresses-pick.component.html',
	styleUrls: ['./stacked-addresses-pick.component.css'],
	animations: [fadeInOut]
})
export class StackedAddressesPickComponent implements OnInit, OnDestroy {

	addresses: StackedAddressItem[];

	isOpen: boolean;

	private addressSub: Subscription;

	constructor(
		private elemRef: ElementRef,
		private activityService: ActivityService
	) { }

	clickOk() {
		// const selectedIds = this.addresses.filter(i => i.isChecked).map(i => i.id);
		const selectedIds = this.activityService.selectedRecordsBS.getValue().ids;
		const newSelectedIds = this.addresses.filter(i => i.isChecked).map(i => i.id);
		this.activityService.selectedRecordsBS.next({
			ids: newSelectedIds
		})
		this.isOpen = false;
	}
	ngOnInit() {
		this.addressSub = this.activityService.stackAddressesSelectBS.subscribe(data => {
			this.isOpen = data.isOpen;
			if (this.isOpen) {
				this.addresses = data.list || [];
			}
			if (data.position) {
				this.elemRef.nativeElement.style.top = data.position[1] + 'px';
				this.elemRef.nativeElement.style.left = data.position[0] + 'px';
			}
		})
	}
	ngOnDestroy(): void {
		this.addressSub.unsubscribe();
	}

}
